const modeOptions = [
  { label: "Air Freight", value: 0 },
  { label: "Road Freight", value: 1 },
  { label: "Sea Freight", value: 2 },
  { label: "Rail Freight", value: 3 },
];
export default modeOptions;
